import { z } from 'zod';
import { HHMM_RE } from './settings.siteWorkerDay.schema.js';

/**
 * WHEN THE NIGHT CREW STARTS, company-wide (owner, 2026-10-26: "it's called
 * night shift, but mainly they start at 12 — make it available as an option in
 * worker timing in Settings"). Stored at `defaultWorkday.nightShiftStartTime`,
 * "HH:MM" in the company zone.
 *
 * Read only on a two-shift site (`Worksite.twoShifts`), and only where that
 * site leaves its own `nightStartsAt` blank — a site's own time wins. The
 * NIGHT lane of dispatch day D starts at this time ON D, so the default 00:00
 * is the night that OPENS day D; an evening time (18:00) is the night that
 * opens on the evening of D. `dispatch.lanes.ts` holds the rule.
 *
 * Moves no pay figure: it decides only when a night-lane worker becomes due,
 * so before it nothing calls him absent or "not in yet".
 */
export const NightShiftStartSchema = z.string().regex(HHMM_RE, 'Expected HH:MM').default('00:00');
